import React, { useEffect, useState } from "react";
import { Header } from "../../components/SpearParts/Layouts/Header";
import { Footer } from "../../components/SpearParts/Layouts/Footer";
import { Link } from "react-router-dom";
import Axios from "../../axios/axios";
import html2pdf from "html2pdf.js";
import TopNavBar from "../../components/SpearParts/Layouts/TopNavBar";
import TopSearchBar from "../../components/SpearParts/Layouts/TopSearchBar";

export default function PaymentList() {
  const [transactions, setTransactions] = useState([]);
  const [customerId, setCustomerId] = useState(null);

  useEffect(() => {
    // Retrieve customer ID from session storage
    const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    if (userInfo && userInfo.customerId) {
      setCustomerId(userInfo.customerId);
    }
  }, []);

  useEffect(() => {
    const fetchTransactions = async () => {
      if (!customerId) return; // Don't fetch if customerId is not set
      try {
        const response = await Axios.get(`/receipts/${customerId}`);
        setTransactions(response.data);
        console.log(response.data);
      } catch (error) {
        console.error("Error fetching transactions:", error);
      }
    };

    fetchTransactions();
  }, [customerId]);

  const handleDownloadReceipt = (transaction) => {
    const pdfContent = document.createElement("div");
    pdfContent.innerHTML = generatePDFContent(transaction);

    const options = {
      margin: 0.5,
      filename: `payment_receipt_${transaction._id}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };

    html2pdf().from(pdfContent).set(options).save();
  };

  const generatePDFContent = (transaction) => {
    return `
    <div style="padding: 20px; font-family: Arial; max-width: 700px; margin: auto; color: #000; font-size: 14px;">
      <div style="text-align: center; margin-bottom: 20px;">
        <img src="/images/logo.svg" alt="Company Logo" style="height: 40px;" />
        <br />
        <h2 style="margin-top: 10px;">Payment Receipt</h2>
      </div>

      <table style="width: 100%; max-width: 400px; margin: 0 auto 30px auto; border-collapse: collapse;">
        <tbody>
          <tr>
            <td style="padding: 6px 12px; text-align: left;"><strong>Customer Name:</strong></td>
            <td style="padding: 6px 12px; text-align: left;">${
              transaction.customerName
            }</td>
          </tr>
          <tr>
            <td style="padding: 6px 12px; text-align: left;"><strong>Order Number:</strong></td>
            <td style="padding: 6px 12px; text-align: left;">#${
              transaction.orderNumber
            }</td>
          </tr>
          <tr>
            <td style="padding: 6px 12px; text-align: left;"><strong>Transaction ID:</strong></td>
            <td style="padding: 6px 12px; text-align: left;">${
              transaction._id
            }</td>
          </tr>
          <tr>
            <td style="padding: 6px 12px; text-align: left;"><strong>Date:</strong></td>
            <td style="padding: 6px 12px; text-align: left;">${new Date(
              transaction.date
            ).toLocaleDateString()}</td>
          </tr>
          <tr>
            <td style="padding: 6px 12px; text-align: left;"><strong>Amount:</strong></td>
            <td style="padding: 6px 12px; text-align: left;">AED ${transaction.transactionAmount.toFixed(
              2
            )}</td>
          </tr>
          <tr>
            <td style="padding: 6px 12px; text-align: left;"><strong>Payment Method:</strong></td>
            <td style="padding: 6px 12px; text-align: left;">${
              transaction.paymentMethod || "Bank Transfer"
            }</td>
          </tr>
        </tbody>
      </table>

      <div style="font-size: 14px; color: #333; text-align: center;">
        <p>Thank you for your payment. This receipt serves as official proof of the transaction.</p>
      </div>

      <div style="margin-top: 40px; font-size: 12px; color: gray; text-align: center;">
        <p>For any queries, contact us at <strong>support@ASIAPARTS.com</strong></p>
        <p><strong>Asia Part Souq</strong> | www.asiapartsouq.com</p>
      </div>
    </div>
  `;
  };

  const sectionStyle = {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundImage: "url(/images/bnr-bg.png)",
  };

  return (
    <div style={sectionStyle}>
      {/* <Header /> */}
      <div className="Main-div">
        <TopNavBar />
        <div className="TopSearchBar">
          <TopSearchBar />
        </div>
        <section class="orders payments">
          <div class="container">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb p-0">
                <li>
                  <a href="search-result.html" class="back">
                    <i class="fa fa-long-arrow-left" aria-hidden="true"></i>{" "}
                    &nbsp;&nbsp;
                  </a>
                </li>
                <li class="breadcrumb-item">
                  <Link to="/account">Account </Link>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  Payments
                </li>
              </ol>
            </nav>
            <div class="row no-gutters">
              <div class="col-lg-6">
                <h3 class="text-uppercase mb-5">Payments</h3>
              </div>
              <div class="col-lg-6">
                {/* <div class="form-row order-search">
						<div class="col-lg-4 column-1 col-12">
							<a href="new-payment.html" class="a-action">Add new payment</a>
						</div>
						<div class="col-lg-3 column-2">
							<select class="form-control" id="exampleFormControlSelect1">
								<option selected disabled>Currency</option>
								<option>AED</option>
								<option>EUR</option>
							</select>
						</div>
						<div class="col-lg-2 my-auto column-3 col-6"><a data-toggle="modal" data-target="#exampleModalCenter">Filter &nbsp;&nbsp;<img src="images/filter.png"/></a></div>
						<div class="col-lg-3 my-auto column-4 col-6"><a href="#" class="export"><span>Export as PDF &nbsp;&nbsp;<img src="images/pdf.png"/></span></a></div>
					</div> */}
              </div>
            </div>

            <div className="table-wrapper">
              <div className="table-responsive">
                <table className="table search-inner-table head-table text-center mx-auto">
                  <thead>
                    <tr>
                      <th className="align-middle" width="70">
                        S.No
                      </th>
                      <th className="align-middle" width="130">
                        Date
                      </th>
                      <th className="align-middle" width="110">
                        Amount
                      </th>
                      <th className="align-middle" width="150">
                        Mode of Payment
                      </th>
                      <th className="align-middle" width="150"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {transactions.length > 0 ? (
                      transactions.map((transaction, index) => (
                        <tr key={index}>
                          <td className="align-middle">{index + 1}</td>
                          <td className="align-middle">
                            {new Date(transaction.date).toLocaleDateString()}
                          </td>
                          <td className="align-middle">
                            AED {transaction.transactionAmount.toFixed(2)}
                          </td>
                          <td className="align-middle">
                            {transaction.paymentMethod || "Bank Transfer"}
                          </td>
                          <td className="align-middle">
                            <button
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => handleDownloadReceipt(transaction)}
                            >
                              <i className="fas fa-file-pdf"></i> Download Bill
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center">
                          {customerId ? "No transactions found." : "Loading..."}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
      {/* <Footer /> */}
    </div>
  );
}
